/**
 * Sections whose content arrives in B4 (D-205 build sequence): the sidebar entry and the header stay
 * exactly as in the reference; the body is the same placeholder card the Settings grid uses.
 */
import { SettingsCardPlaceholder, useT } from "@faylasuf/ui";
import type { SectionKey } from "../app/Shell.js";

export function PlaceholderPage({ section }: { section: SectionKey }) {
  const t = useT();
  return (
    <div className="space-y-4" data-testid={`placeholder-${section}`}>
      <SettingsCardPlaceholder />
      <p className="text-center text-xs font-bold text-gray-400 dark:text-[#8b949e]">{t("app.page_placeholder_hint")}</p>
    </div>
  );
}
